// extracted by mini-css-extract-plugin
export var clauseRow = "_gp-6";
export var emptyState = "_gp-d";
export var filterContent = "_gp-a";
export var filterGroup = "_gp-1";
export var filterGroupContainer = "_gp-0";
export var nestedGroup = "_gp-2";
export var nestedGroupContent = "_gp-b";
export var nestedGroupDepth1 = "_gp-3";
export var nestedGroupDepth2 = "_gp-4";
export var nestedGroupDepth3 = "_gp-5";
export var nestedGroupEmpty = "_gp-c";
export var operatorAnd = "_gp-8";
export var operatorOr = "_gp-9";
export var operatorToggle = "_gp-7";
export var removeGroupButton = "_gp-e";